export default __webpack_public_path__ + "images/e19be7c3719aec3ad974fc4d5e827ce1-renaissance.jpg";